module.exports = __webpack_public_path__ + "static/pexels-1-dd84797b80d3f589e8792bc153efe0df.jpg";